// extracted by mini-css-extract-plugin
export default {"container":"l_qCb","content":"R5dEz","avatar-container":"VUlRw","avatar-image":"VtIGq","location-pin":"ViTlW"};